import { TieredMenuSub } from 'primeng/tieredmenu';

/**
 * PrimeNG 20: `TieredMenuSub.isItemActive` на каждой проверке изменений и для каждого пункта зовёт `positionSubmenu`,
 * а тот замеряет раскладку (скрытые подменю показывает на время замера, ширину полосы прокрутки — через временный div).
 * На каждое наведение — десятки принудительных перерасчётов, подсветка пунктов тормозит. Как в PrimeNG 21:
 * подменю позиционируется один раз, когда открывается.
 * Убрать после перехода на PrimeNG 21+.
 */
const proto = TieredMenuSub.prototype as unknown as {
  root: boolean;
  level: number;
  sublistViewChild?: { nativeElement: HTMLElement };
  _shown?: boolean;
  positionSubmenu(): void;
  onAfterViewChecked(): void;
};
const position = proto.positionSubmenu;
const afterViewChecked = proto.onAfterViewChecked;

proto.positionSubmenu = () => {};
proto.onAfterViewChecked = function () {
  afterViewChecked.call(this);
  const list = this.sublistViewChild?.nativeElement;
  const shown = !this.root && !!list && list.style.display !== 'none';
  if (shown && !this._shown) position.call(this);
  this._shown = shown;
};
